import { useState } from 'react';

export const useNewsletterForm = () => {
  const [form, setForm] = useState({
    email: {
      value: '',
      error: false,
      errorMessage: ''
    },
  });
  return {
    form,
    setFormValue: ({field, newValue}) => {
      setForm((prev) => {
        return {
          ...prev,
          [field]: {
            ...prev[field],
            value: newValue
          }
        };
      });
    },
    setFormError: ({field, errorMessage, errorStatus}) => {
      setForm((prev) => {
        return {
          ...prev,
          [field]: {
            ...prev[field],
            errorMessage,
            error: errorStatus
          }
        };
      });
    },
  };
};

export const useSubscribeStatus = () => {
  const [subscribeStatus, setSubscibeStatus ] = useState(false);
  const handleSubscribeStatus = () => {
    setSubscibeStatus(true);
    setTimeout(() => setSubscibeStatus(false), 10000);
  };
  return { subscribeStatus, handleSubscribeStatus };
};